/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateSupportTicketPriorityDto
 */
export interface UpdateSupportTicketPriorityDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSupportTicketPriorityDto
     */
    'priority': UpdateSupportTicketPriorityDtoPriorityEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateSupportTicketPriorityDtoPriorityEnum {
    Low = 'LOW',
    Normal = 'NORMAL',
    High = 'HIGH',
    Urgent = 'URGENT'
}


